import React, {useEffect, useState} from 'react';
import {Button, Input, Form, message} from 'antd';
import {internalApi} from '../../common/axios';

const PasswordRecovery = ({reset, onCancel}) => {
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isResetting, setIsResetting] = useState(false);
    const [timeLeft, setTimeLeft] = useState(1800); // 30 minutes in seconds

    useEffect(() => {
        if (reset) {
            setEmail('');
            setToken('');
            setNewPassword('');
            setConfirmPassword('');
            setIsResetting(false);
            setTimeLeft(1800);
        }
    }, [reset]);

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [timeLeft]);

    const handleRequestReset = async () => {
        try {
            const response = await internalApi.post('/auth/requestPassword', {email});
            message.success(response.data.message);
            setIsResetting(true);
        } catch (error) {
            message.error(error.response.data.message);
        }
    };

    const handleResetPassword = async () => {
        if (newPassword !== confirmPassword) {
            message.error('비밀번호가 일치하지 않습니다.');
            return;
        }
        try {
            const response = await internalApi.post('/auth/resetPassword', {token, newPassword});
            message.success(response.data.message);
            onCancel();
        } catch (error) {
            message.error(error.response.data.message);
        }
    };

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    return (
        <div className="password-recovery">
            {!isResetting ? (
                <Form onFinish={handleRequestReset}>
                    <Form.Item label="Email" name="email" rules={[{required: true, type: 'email'}]}>
                        <Input value={email} onChange={(e) => setEmail(e.target.value)}/>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">보안코드 전송</Button>
                    </Form.Item>
                </Form>
            ) : (
                <Form onFinish={handleResetPassword}>
                    <Form.Item label="보안 코드" name="token" rules={[{required: true}]}>
                        <Input value={token} onChange={(e) => setToken(e.target.value)}/>
                    </Form.Item>
                    <Form.Item label="New Password" name="newPassword" rules={[{required: true}]}>
                        <Input.Password value={newPassword} onChange={(e) => setNewPassword(e.target.value)}/>
                    </Form.Item>
                    <Form.Item label="Confirm Password" name="confirmPassword" rules={[{required: true}]}>
                        <Input.Password value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}/>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" disabled={timeLeft === 0}>비밀번호 변경</Button>
                        {formatTime(timeLeft)}
                    </Form.Item>
                </Form>
            )}
        </div>
    );
};

export default PasswordRecovery;